"use client";

import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-4">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-all duration-200 flex items-center group">
            <span className="w-0 group-hover:w-2 h-[1px] bg-primary mr-0 group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <footer id="footer" className="dark bg-background text-foreground border-t border-primary/20 pt-20 pb-10 px-6 radiating-pattern relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-primary to-transparent opacity-50" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16 mb-20">
          
          {}
          <div className="md:col-span-5 flex flex-col items-start gap-8">
            
            <div className="space-y-4">
              <p className="text-muted-foreground text-base leading-relaxed max-w-sm font-sans">The high-performance missed call recovery system built specifically for UK Sole Traders and Tradespeople. We automate the admin so you can stay on the job.</p>
              
            </div>
          </div>

          {}
          <div className="md:col-span-3">
            <h3 className="h3 text-xl mb-8 text-foreground tracking-tight">
              Navigation
            </h3>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4">
            <h3 className="h3 text-xl mb-8 text-foreground tracking-tight">
              Get In Touch
            </h3>
            <ul className="flex flex-col gap-6 text-sm text-muted-foreground font-sans">
              <li className="flex gap-4 items-start group">
                <div className="mt-1 p-2 rounded bg-muted group-hover:bg-primary/10 transition-colors">
                  <Mail className="size-4 text-primary" />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-[10px] font-bold text-muted-foreground uppercase tracking-[0.2em]">Email Support</span>
                  <Link to="mailto:support@thinklocalpro.com" className="text-foreground hover:text-primary transition-colors font-medium">
                    support@thinklocalpro.com
                  </Link>
                </div>
              </li>
              <li className="flex gap-4 items-start group">
                <div className="mt-1 p-2 rounded bg-muted group-hover:bg-primary/10 transition-colors">
                  <Phone className="size-4 text-primary" />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-[10px] font-bold text-muted-foreground uppercase tracking-[0.2em]">Direct Line</span>
                  <span className="text-foreground font-medium">01452 941841</span>
                </div>
              </li>
              <li className="flex gap-4 items-start group">
                <div className="mt-1 p-2 rounded bg-muted group-hover:bg-primary/10 transition-colors">
                  <MapPin className="size-4 text-primary" />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-[10px] font-bold text-muted-foreground uppercase tracking-[0.2em]">Headquarters</span>
                  <span className="leading-relaxed">Ground Floor, 1 Spa Road,<br />Gloucester, GL1 1UY</span>
                </div>
              </li>
            </ul>
          </div>

        </div>

        {}
        <div className="border-t border-border/50 pt-10 flex flex-col md:flex-row justify-between items-center gap-6 text-[11px] font-medium text-muted-foreground uppercase tracking-widest font-sans">
          <p className="order-2 md:order-1">
            &copy; {new Date().getFullYear()} Think Local SEO Ltd.
          </p>
          <div className="flex gap-8 order-1 md:order-2">
            <Link to="/privacy-policy" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}